import Button, { ButtonLevel } from "components/ui/Button";
import IconList, { IconListItem } from "components/ui/IconList";
import React from "react";
import styled from "styled-components";
import { getPartnerConfig } from "utils/partner";
import Layout from "../Layout";
import Calculator from "./Calculator";
import { SlideProps } from "./types";

const IconListWrapper = styled.div`
  margin-top: -16px;
`;

const FinancialHealth: React.FC<SlideProps> = ({ onContinue }) => {
  const partner = getPartnerConfig();
  const bankName = partner?.name;
  const listItems: IconListItem[] = [
    {
      icon: "loan",
      title: bankName
        ? `Fee-free for ${bankName} members`
        : "Fee-free for members",
      body: "Enjoy daily access to earnings, but lose the high fees from third-party apps.",
    },
    {
      icon: "bank",
      title: "Keep your financial home",
      body: `Access up to 50% of your accrued net earnings when you send your direct deposit to ${
        bankName || "your checking account"
      }.`,
    },
    {
      icon: "piggyBank",
      title: "Responsible access",
      body: "A single, intelligent number keeps you informed and in control:",
    },
  ];

  return (
    <Layout
      heading="EWA the right way."
      actions={
        <Button level={ButtonLevel.cta} fullWidth onClick={onContinue}>
          Let's Go!
        </Button>
      }
    >
      <IconListWrapper>
        <IconList items={listItems} isLarge />
      </IconListWrapper>

      <Calculator />
    </Layout>
  );
};

export default FinancialHealth;
